import './missionList.less';
import * as _ from 'lodash';
import { EntityCollection } from '../misc/EntityCollection';
import { MissionStatus } from '../objects/Mission';
import { NoPartyOption } from '../objects/Party';

function createCriteria(paramsCriteria) {

    let criteria = {
        MissionStatus: MissionStatus.ActiveOrFuture,
        OnlyCurrentMandatePeriod: true,
    };

    _.extend(criteria, _.cloneDeep(paramsCriteria));

    return criteria;
}

angular.module("tromanWeb").controller('MissionListController', ['$q', 'stateService', 'tromanServer', 'ObjectCache', 'dialogService', function ($q, stateService, tromanServer, ObjectCache, dialogService) {

    function searchWithCriteria(criteria) {
        var sc = _.cloneDeep(criteria);

        let noPartyIndex = _.indexOf(sc.PartyIds, NoPartyOption.Id);
        if (noPartyIndex >= 0) {
            sc.PartyIds.splice(noPartyIndex, 1);
            sc.WithoutParty = true;
        }

        return tromanServer.Missions.search(sc);
    }

    this.loading = true;
    this.table = null;
    this.items = null;

    this.$onInit = function $onInit() {
        const params = stateService.getParams();

        this.criteria = createCriteria(params.criteria);
        this.filter = params.filter;

        this._loadItems($q.all({
            organizations: ObjectCache.allOrganizations(),
            parties: ObjectCache.allParties(),
            organizationTypes: ObjectCache.getOrganizationTypes(),
            missionTypes: ObjectCache.getMissionTypes(),
            missions: params.criteria && searchWithCriteria(this.criteria),
        }).then(data => {
            this.organizations = new EntityCollection(data.organizations);
            this.parties = new EntityCollection([NoPartyOption].concat(data.parties));
            this.organizationTypes = data.organizationTypes;
            this.missionTypes = data.missionTypes;
            return data.missions;
        }));
    };

    this.uiOnParamsChanged = function (changed) {
        if (_.has(changed, 'criteria')) {
            this.criteria = createCriteria(changed.criteria);
            this._loadItems(searchWithCriteria(this.criteria));
        }

        if (_.has(changed, 'filter')) {
            this.filter = changed.filter;
        }
    };

    this._loadItems = function (missionPromise) {
        this.loading = true;

        missionPromise.then(data => {
            this.error = null;
            // The desired sorting order is OrganizationName then Start
            // The organization name sorting needs to be done by smart-table so that the UI reflects the current sort column.
            // Just sort by start here.
            this.items = _.orderBy(data, x => x.Start);
        }).catch(err => {
            this.error = err;
            this.items = null;
        }).finally(() => {
            this.loading = false;
        });
    };

    this.resetCriteria = function resetCriteria() {
        this.criteria = createCriteria(null);
    };

    this.canSearch = function canSearch() {
        return this.searchForm.$valid && !this.loading;
    };

    this.search = function search() {
        if (this.searchForm) {
            this.searchForm.$commitViewValue();
        }
        if (!this.canSearch()) return false;

        stateService.reloadWithParams({ criteria: _.cloneDeep(this.criteria) });
    };

    this.filterChanged = function filterChanged() {
        stateService.replaceParams({ filter: this.filter });
    };

    this.createList = function createList() {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.createMissionList(list);
    };

    this.emailList = function emailList() {
        if (this.table == null) return;
        var list = this.table.selectedItems()
            .map(x => x.Person)
            .filter(x => x != null);
        dialogService.createEmailList(list);
    };

    this.addToMissionGroup = function () {
        if (this.table == null) return;
        var list = this.table.selectedItems();
        dialogService.addToMissionGroup(list);
    };

    this.edit = function (mission) {
        dialogService.editMission(mission).then(() => this.search());
    };

    this.selectedOrganizationsChanged = function selectedOrganizationsChanged() {
        if (this.organizations.some(this.criteria.OrganizationIds, x => !x.Active)) {
            this.criteria.OnlyCurrentMandatePeriod = false;
            this.criteria.MissionStatus = null;
        }
    };

    this.selectedPartiesChanged = function selectedOrganizationsChanged() {
        if (this.parties.some(this.criteria.PartyIds, x => !x.Active)) {
            this.criteria.OnlyCurrentMandatePeriod = false;
            this.criteria.MissionStatus = null;
        }
    };
}]);
